import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { DatacapResponse, DCDirectResponse } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapAuthResponse.dto';
import { KioskPaymentRequest } from 'src/app/shared/models/DTO/FocusPayDatacap/KioskPaymentRequest.dto';
import { WebsocketPayTransactionPayload } from 'src/app/shared/models/DTO/PayDevicePaymentRequest.dto';
import { LogLevel } from 'src/app/shared/models/enums/log-level.enum';
import { OrderSocketMessage } from 'src/app/shared/models/enums/order-socket-message.enum';
import { AppService } from './app.service';
import { DeviceService } from './device.service';
import { FocuslinkService } from './focuslink.service';
import { LocalDataStoreService } from './local-data-store.service';

@Injectable({
	providedIn: 'root',
})
export class KioskPaymentService {
	currentCheckKey: string;
	paymentRequest: WebsocketPayTransactionPayload;

	paymentResponseSubscriptpion: Subscription;

	paymentResponse: Subject<DCDirectResponse> = new Subject<DCDirectResponse>();

	dcDirectTimeout;

	venueKey: number;

	constructor(private app: AppService, private storage: LocalDataStoreService, private focuslink: FocuslinkService, public deviceService: DeviceService) {}

	async initKiosk(venueKey: number) {
		const licenseKey = await this.storage.get('kioskDeviceId');
		const licenseSecret = await this.storage.get('kioskLicenseSecret');
		console.log(licenseKey);
		this.deviceService.licenseKey = licenseKey;
		this.deviceService.licenseSecret = licenseSecret;
	}

	async buildPaymentRequest(checkKey: string, transactionTotalWithoutTipOrTax: number, transactionTip?: number) {
		this.paymentRequest = new WebsocketPayTransactionPayload({
			checkKey: checkKey,
			invoiceNo: this.app.moment().unix().toString(),
			transactionAmount: transactionTotalWithoutTipOrTax,
			transactionTip: transactionTip || 0,
			transactionTax: 0,
			payTransactionKey: this.app.uuidv4(),
			payTransactionRequestSourceKey: await this.kioskDeviceId(),
		});
		this.currentCheckKey = checkKey;
		return this.paymentRequest;
	}

	completePaymentProcess(paymentResponse: DatacapResponse) {
		// this.kioskService.paymentResponseAttachToOrder(paymentResponse, 0);
	}

	async kioskDeviceId(): Promise<string> {
		return await this.storage.get('kioskDeviceId');
	}

	async performPaymentRequest(venueKey: number, paymentRequest): Promise<KioskPaymentRequest> {
		this.venueKey = venueKey;
		return await this.focuslink.paymentRequest(venueKey, await this.kioskDeviceId(), paymentRequest);
	}

	async paymentRequestCheckStatus(venueKey: number, requestKey: string): Promise<KioskPaymentRequest> {
		return await this.focuslink.paymentResponse(venueKey, requestKey);
	}

	async removeLicense() {
		await this.storage.remove('kioskDeviceId');
		await this.storage.remove('kioskLicenseSecret');
	}

	async subscribeToPaymentResponse() {
		const kioskDeviceId = await this.kioskDeviceId();
		this.paymentResponseSubscriptpion = this.deviceService.socket.subscribe((message) => {
			if (message?.message === OrderSocketMessage.PAYTRANSACTION && message?.destinationLicenseKey === kioskDeviceId) {
				console.log(`PayRequestResponse`);

				const datacapResponse = new DatacapResponse(message.payload);
				console.log(datacapResponse);

				if (message.dcDirect) {
					const dcDirectResponse = new DCDirectResponse(message.payload);
					this.paymentResponse.next(dcDirectResponse);
					this.focuslink.log(this.venueKey, 'kiosk-payment-response', LogLevel.INFO, {
						message: message,
					});
				}

				// if (datacapResponse.checkKey === this.currentCheckKey) {
				// 	this.paymentResponse.next(datacapResponse);
				// }
			}
		});
	}
}
